import React, { useContext, useRef } from 'react';
import { Tabs as Tabs, Tab as Tab } from '@hz-design-system/web-ui';

import { TFeeds } from 'types/TFeeds';
import useSticky from '../../hooks/useSticky';
import EnvironmentContext from '../../../../contexts/EnvironmentContext';

import Classes from './FeedsTabs.scss';

type TFeedsTabsProps = {
  feeds: TFeeds;
  activeFeedIndex: number;
  onClick: Function;
};

const FeedsTabs = ({ feeds, activeFeedIndex, onClick }: TFeedsTabsProps) => {
  const { isHeaderSticky } = useContext(EnvironmentContext);
  const stickyStyle = useSticky(isHeaderSticky ? ['header'] : []);

  const ref = useRef<HTMLInputElement>(null);

  const setActiveTab = (index) => {
    const topPosition = ref?.current?.getBoundingClientRect().top ?? 0;
    if (topPosition < stickyStyle.top) {
      window.scrollBy({
        top: topPosition - stickyStyle.top,
        left: 0,
        behavior: 'smooth',
      });
    }

    if (index !== activeFeedIndex) {
      onClick(index);
    }
  };

  return (
    <>
      {/* An empty div helps us to calculate where to we have to scroll up*/}
      <div ref={ref} />
      <Tabs className={Classes.tabs} style={stickyStyle} activeTab={activeFeedIndex} setActiveTab={setActiveTab}>
        {feeds.map((feed, index) => (
          <Tab key={index} label={feed.displayTitle} />
        ))}
      </Tabs>
    </>
  );
};

export default FeedsTabs;
